import {getOwnedNodes, isNodeOwnerLikeNode, SwitchNode} from "@cm/template-nodes"
import type {NodeOwnerLikeNode, TemplateNode} from "@cm/template-nodes"

export type TemplateTreeNode<T extends TemplateNode = TemplateNode> = {
    parent: TemplateTreeNode<NodeOwnerLikeNode | SwitchNode> | null
    node: T
}

export const createTemplateTreeNode = <T extends TemplateNode>(
    parent: TemplateTreeNode<NodeOwnerLikeNode | SwitchNode> | null,
    node: T,
): TemplateTreeNode<T> => {
    return {node, parent}
}

export const hasChildren = (node: TemplateTreeNode): node is TemplateTreeNode<NodeOwnerLikeNode | SwitchNode> => {
    const {node: nodeValue} = node
    return isNodeOwnerLikeNode(nodeValue) || nodeValue instanceof SwitchNode
}

export const getTemplateTreeNodeId = (node: TemplateTreeNode): string => {
    const {parent} = node
    if (!parent) return `${node.node.instanceId}`
    else return `${parent.node.instanceId}-${node.node.instanceId}`
}

export const getNodeChildren = (node: TemplateTreeNode): TemplateTreeNode[] => {
    const {node: nodeValue} = node
    if (isNodeOwnerLikeNode(nodeValue)) return getOwnedNodes(nodeValue).map((x) => createTemplateTreeNode(node as TemplateTreeNode<NodeOwnerLikeNode>, x))

    if (nodeValue instanceof SwitchNode) {
        return getOwnedNodes(nodeValue).map((x) => createTemplateTreeNode(node as TemplateTreeNode<SwitchNode>, x))
    }

    return []
}
